<template>
  <div class="toutiao-contianer">
    <Card title="基础信息">
      <a-form-model
        class="ant-advanced-search-form"
        :model="siteForm"
        layout="horizontal"
        :labelCol="{ span: 5 }"
        :wrapperCol="{ span: 18, offset: 1 }"
        :rules="rules"
        ref="form"
      >
        <div class="form-container">
          <a-form-model-item label="站点类型" required>
            <a-input disabled v-model="siteForm.spiderClassType" size="large" />
          </a-form-model-item>

          <a-form-model-item label="国家" required prop="countryCode">
            <CountrySelect v-model="siteForm.countryCode" size="large" />
          </a-form-model-item>

          <a-form-model-item label="语言" required prop="langCode">
            <LangSelect v-model="siteForm.langCode" size="large" />
          </a-form-model-item>

          <a-form-model-item label="用户ID" required prop="accountId">
            <a-input v-model="siteForm.accountId" size="large" />
          </a-form-model-item>

          <a-form-model-item label="用户名称" required prop="accountName">
            <a-input v-model="siteForm.accountName" size="large" />
          </a-form-model-item>

          <a-form-model-item label="调度周期时间" prop="spiderExecTimeCycle">
            <a-input-group compact>
              <a-input-number
                :min="1"
                :max="max"
                style="width: calc(100% - 90px)"
                v-model="siteForm.spiderExecTimeCycle"
                size="large"
              >
              </a-input-number>
              <a-select style="width: 90px" v-model="siteForm.spiderExecTimeType" size="large">
                <a-select-option :value="0"> 秒/次 </a-select-option>
                <a-select-option :value="1"> 分/次 </a-select-option>
                <a-select-option :value="2"> 时/次 </a-select-option>
                <a-select-option :value="3"> 天/次 </a-select-option>
                <a-select-option :value="4"> 月/次</a-select-option>
              </a-select>
            </a-input-group>
          </a-form-model-item>

          <a-form-model-item label="账号描述" required prop="accountDesc">
            <a-textarea v-model="siteForm.accountDesc" size="large" />
          </a-form-model-item>

          <!-- <a-form-model-item label="IP代理设置">
            <a-textarea v-model="siteForm.ipConfig.url" size="large" />
          </a-form-model-item> -->
          <a-form-model-item label="IP代理">
            <a-radio-group button-style="solid" v-model="siteForm.ipConfig.enabled">
              <a-radio-button :value="0"> 关 </a-radio-button>
              <a-radio-button :value="1"> 开 </a-radio-button>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item
            v-if="siteForm.ipConfig.enabled == 1"
            label="代理国家"
            :prop="Boolean(siteForm.ipConfig.enabled) ? 'ipConfigCountry' : ''"
          >
            <CountrySelect v-model="siteForm.ipConfigCountry" />
          </a-form-model-item>

          <a-form-model-item
            v-if="siteForm.ipConfig.enabled == 1"
            label="代理数量"
            :prop="Boolean(siteForm.ipConfig.enabled) ? 'ipConfigNum' : ''"
          >
            <a-input-number
              v-model="siteForm.ipConfigNum"
              style="width: 100%"
              placeholder="请输入IP代理数量"
            />
          </a-form-model-item>

          <a-form-model-item label="标签设置" prop="spiderTags">
            <div class="tags-inner">
              <Tag
                v-for="(tag, index) in siteForm.spiderTags"
                :onDelete="() => onSelectTag(tag)"
                :key="index"
              >
                <a-tooltip :title="tag.spiderTagName" :delay="1000">
                  {{ tag.spiderTagName }}
                </a-tooltip>
              </Tag>
              <div class="add-tag" @click="isShowTagSelectorModal = true">+ 添加标签</div>
            </div>
          </a-form-model-item>
        </div>
      </a-form-model>
    </Card>

    <div class="bts-container">
      <a-button
        type="primary"
        size="large"
        :style="{ width: '100px', display: 'block', marginBottom: '12px' }"
        @click="back()"
        v-if="editId"
        >返回</a-button
      >
      <a-button
        type="primary"
        size="large"
        :style="{ width: '100px' }"
        :loading="loading"
        @click="submit"
        >{{ editId ? '修改' : '创建' }}</a-button
      >
    </div>

    <a-modal
      title="选择标签"
      :visible="isShowTagSelectorModal"
      okText="确定"
      cancelText="取消"
      :closable="false"
      @cancel="isShowTagSelectorModal = false"
      @ok="isShowTagSelectorModal = false"
      :width="725"
    >
      <div class="tags-modal-contianer">
        <Tag
          v-for="(tag, index) in labels"
          :key="index"
          :isActive="siteForm.spiderTags.map((t) => t.spiderTagId).includes(tag.spiderTagId)"
          :onSelect="() => onSelectTag(tag)"
          :canDelete="false"
          class="atag"
        >
          <a-tooltip :title="tag.spiderTagName" :delay="1000">
            {{ tag.spiderTagName }}
          </a-tooltip>
        </Tag>
      </div>
    </a-modal>
  </div>
</template>

<script>
import Card from '../components/Card'
import CountrySelect from '@/components/CountrySelect/'
import LangSelect from '@/components/LangSelect/'
import SelectTag from '@/components/SelectTag2/'
import { queryTagListApi, getSpiderApiByIdApi, updateSpiderApiItemApi } from '@/api/Site/Create'
import { onHttpResponseSilent } from '@/utils/request'
import Tag from '../components/Tag'

import { addSpiderApiItem } from '@/api/Site/Create'
import { onHttpResponse } from '@/utils/request'

export default {
  components: { Card, CountrySelect, LangSelect, SelectTag, Tag },

  props: {
    onSubmited: {
      type: Function
    },
    id: {},
    type: {}
  },

  data() {
    return {
      siteForm: {
        spiderId: '',
        spiderClassId: '',
        spiderName: '',
        spiderClassType: 'toutiao',
        accountId: '',
        accountName: '',
        accountDesc: '',
        countryCode: 'cn',
        langCode: 'zh',
        spiderLevel: 2,
        deployType: 0,
        spiderExecTimeType: 1,
        spiderExecTimeCycle: 10,
        execType: null,
        spiderTags: [],
        ipConfig: {
          enabled: 0
          // url: 'http://ip-pool-service-master-starsee.prod.k8s.starsee.it/ip_pool/getIp?num=3&type=2&country=cn'
        },
        // 下面配置项不知道是啥
        // 上面的其实也不知道
        whiteConfig: {
          hosts: [],
          path: []
        },
        blackConfig: {
          hosts: [],
          path: []
        },
        spiderUrls: [
          'https://www.toutiao.com/toutiao/api/pc/feed/?category=profile_all&utm_source=toutiao&visit_user_token=%s&max_behot_time=0'
        ],
        synNum: 1 // 线程数
      },
      spiderParse: {
        spiderParseType: 1,
        spiderParseConfigs: [
          {
            urls: ['toutiao.com/*'],
            parseId: 'toutiao_news_parse_id',
            spiderConfigs: [
              {
                name: 'title',
                rule: "//div[@class='article-content']/h1/text()"
              },
              {
                name: 'content',
                rule:
                  "//div[@class='article-content']//p//span//text()|//div[@class='article-content']//p//text()|//div[@class='weitoutiao-html']//text()"
              },
              {
                name: 'publisher',
                rule: "//div[@class='article-meta']/span[4]/a/text()"
              },
              {
                name: 'publish_time',
                // rule: "//div[@class='article-meta']/span[2]/text()"
                rule: "////div[@class='article-meta']//span"
              },
              {
                name: 'keywords',
                rule: "//meta[@name='keywords']/@content"
              },
              {
                name: 'file',
                rule: "//div[@class='article-content']//img/@src"
              },

              {
                name: 'description',
                rule: "//meta[@name='description']/@content"
              }
            ]
          }
        ]
      },
      rules: {
        countryCode: [{ required: true, message: '国家必填', trigger: 'change' }],
        langCode: [{ required: true, message: '语言必填', trigger: 'change' }],
        accountId: [{ required: true, message: '用户ID必填', trigger: 'blur' }],
        accountName: [{ required: true, message: '用户名称必填', trigger: 'blur' }],
        spiderName: [{ required: true, message: '站点名称必填', trigger: 'change' }],
        accountDesc: [{ required: true, message: '账号描述必填', trigger: 'blur' }],
        ipConfigCountry: [{ required: true, message: '代理国家必填', trigger: 'change' }],
        ipConfigNum: [{ required: true, message: '代理数量必填', trigger: 'blur' }]
        // spiderExecTimeCycle: {
        //   required: true,
        //   type: 'number',
        //   asyncValidator: (_, value) => {
        //     return new Promise((resolve, reject) => {
        //       if (value >= 1 && value <= this.max) {
        //         resolve()
        //       } else {
        //         reject('时间周期不合法')
        //       }
        //     })
        //   },
        //   trigger: 'blur'
        // }
      },

      labels: [],
      isShowTagSelectorModal: false,

      loading: false,

      editId: undefined
    }
  },

  computed: {
    max() {
      let { spiderExecTimeType } = this.siteForm
      let max = 0
      if (spiderExecTimeType == 0 || spiderExecTimeType == 1) {
        max = 59
      } else if (spiderExecTimeType == 2) {
        return 23
      } else if (spiderExecTimeType == 3) {
        max = 31
      } else {
        max = 12
      }
      return max
    }
  },
  // watch: {
  //   'siteForm.spiderExecTimeType'() {
  //     console.log(1)
  //     if (this.$refs.form) {
  //       this.$refs.form.validateField('spiderExecTimeCycle')
  //     }
  //   }
  // },

  mounted() {
    this.getLabels()

    // const { spiderClassId } = this.$route.query
    // if (spiderClassId) {
    //   this.siteForm.spiderClassId = spiderClassId
    // }

    // let { spiderId } = this.$route.query
    if (this.id) {
      // 这是修改
      this.getSpiderById(this.id)
      this.editId = this.id
    }
  },

  methods: {
    back() {
      // sessionStorage.types = 'others'
      // this.$router.back(-1)
      this.$emit('back')
    },
    getLabels() {
      queryTagListApi({

      })
        .then(onHttpResponseSilent)
        .then(({ data }) => {
          this.labels = data
        })
    },

    onSelectTag(tag) {
  
      if (this.siteForm.spiderTags.map((t) => t.spiderTagId).includes(tag.spiderTagId)) {
        this.siteForm.spiderTags = this.siteForm.spiderTags.filter(
          (t) => t.spiderTagId !== tag.spiderTagId
        )
      } else {
        this.siteForm.spiderTags.push(tag)
      }
    },

    getPostData(runNow) {
      return {
        ...this.siteForm,
        spiderName: this.siteForm.accountName,
        mqConfig: window.spider.default.mqConfig,
        execType: runNow ? 1 : 0,
        spiderParse: this.spiderParse
      }
    },

    validateForm() {
      return new Promise((resolve, reject) => {
        this.$refs.form.validate((valid) => {
          if (valid) {
            resolve()
          } else {
            reject()
          }
        })
      })
    },

    async getSpiderById() {
      await getSpiderApiByIdApi({ spiderId: this.id })
        .then(onHttpResponseSilent)
        .then(({ extra }) => {
          this.siteForm = Object.assign(this.siteForm, extra.data)
        })
    },

    reset() {
      if (this.editId) {
        // let { spiderId } = this.$route.query
        this.getSpiderById(this.id)
      } else {
        this.siteForm.countryCode = 'cn'
        this.siteForm.langCode = 'zh'
        this.siteForm.accountId = ''
        this.siteForm.accountName = ''
        this.siteForm.spiderExecTimeType = 1
        this.siteForm.spiderExecTimeCycle = 10
        this.siteForm.accountDesc = ''
        this.siteForm.spiderTags = []
      }
    },

    submit() {
      this.validateForm()
        .then(() => {
          if (this.editId) {
            this.updateSpiderItem()
          } else {
            this.addSpiderItem()
          }
        })
        .catch((err) => {
          console.log('err', err)
        })
    },

    async addSpiderItem() {
      return new Promise((resolve) => {
        const confirm = this.$confirm({
          title: '调度任务确认',
          content: '是否立刻开启调度任务?',
          autoFocusButton: 'ok',
          cancelText: '暂不开启',
          okText: '立即开启',
          maskClosable: true,
          onOk: async () => {
            await this._addSpiderItem(true)
            resolve()
          },
          onCancel: async (e) => {
            if (typeof e === 'object' && e.triggerCancel) {
              confirm.destroy()
              resolve()
            } else {
              await this._addSpiderItem(false)
              resolve()
            }
          }
        })
      })
    },

    async updateSpiderItem() {
      this.loading = true

      let postData = this.getPostData()
      delete postData.execType
      updateSpiderApiItemApi(postData)
        .then(onHttpResponseSilent)
        .then(() => {
          if (this.onSubmited) {
            this.onSubmited(res)
          } else {
            // this.$router.push({ name: 'site_manage', query: { type: 'toutiao' } })
            this.back()
          }
        })
        .finally(() => {
          this.loading = false
        })
    },

    async _addSpiderItem(runNow) {
      this.loading = true
      let postData = this.getPostData(runNow)
      return addSpiderApiItem(postData)
        .then(onHttpResponse)
        .then(() => {
          this.$router.push({ name: 'site_manage', query: { type: 'toutiao' } })
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style lang="less" scoped>
.toutiao-contianer {
  width: calc(100% - 200px);
  position: relative;

  .form-container {
    width: 100%;
    display: grid;
    grid-template-columns: 45% 45%;
    gap: 0 60px;

    .tags-inner {
      display: grid;
      grid-template-columns: repeat(auto-fill, 86px);
      gap: 10px;

      .add-tag {
        width: 100%;
        height: 36px;
        border-radius: 4px;
        background: #1990ff;
        color: white;
        border: none;
        line-height: 34px;
        text-align: center;
        cursor: pointer;
      }
    }
  }

  .bts-container {
    position: absolute;
    right: -180px;
    bottom: 0px;
  }
}

.tags-modal-contianer {
  display: grid;
  grid-template-columns: repeat(auto-fill, 88px);
  gap: 10px;
}
.atag:hover {
  background: #3c93ff;
  color: #fff;
}
</style>
